import { Component } from '@angular/core';
import { LoaderComponent } from '../../utils/loader/loader.component';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { DevicesService } from '../../services/devices.service';
import { MovementsService } from '../../services/movements.service';

import { jwtDecode } from 'jwt-decode';
import { LoginUserModel } from '../../models/loginUserModel';
import { CustomTableComponent } from '../../utils/custom-table/custom-table.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { CommonModule, CurrencyPipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

import { SelectModule } from 'primeng/select';
import { StepsModule } from 'primeng/steps';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { DialogModule } from 'primeng/dialog';

import { LoginServicesService } from '../../services/login-services.service';
import { LogService } from '../../services/log.service';
import { parseSync } from 'svgson';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../theme.service';
import { CustomTableIconComponent } from "../../utils/custom-table-icon/custom-table-icon.component";
import { UsersService } from '../../services/users.service';
import { firstValueFrom } from 'rxjs';
import { ToastService } from '../../services/toast.service';

@Component({
    selector: 'app-qrcode',
    imports: [
        LoaderComponent, FormsModule, ReactiveFormsModule, CommonModule,
        CustomTableComponent, NgxMaskDirective,
        CustomTableIconComponent,
        TableModule, ButtonModule, InputTextModule, IconFieldModule, InputIconModule,
        StepsModule, SelectModule, ToggleSwitchModule, DialogModule
    ],
    templateUrl: './qrcode.component.html',
    styleUrl: './qrcode.component.scss',
    providers: [provideNgxMask(), CurrencyPipe]
})
export class QRcodeComponent {
  filterStatus='A';
  isLoader: boolean = false;
  isChoice: boolean = false;
  loadingBalance = false;
  loadingUsers = false;
  headersUsers: any[] = [
    { key: "userId", textHeader: "Seleccionar", visible: true, },
    { key: "name", textHeader: "Nombre", visible: true, type: "string" },
    { key: "phone", textHeader: "Teléfono", visible: true, type: "string" },
    { key: "email", textHeader: "Correo", visible: true, type: "string" }
  ];

  headersDrivers: any[] = [
    { key: "driver_id", textHeader: "Seleccionar", visible: true, },
    { key: "name", textHeader: "Nombre", visible: true, type: "string" },
    { key: "phone_number", textHeader: "Teléfono", visible: true, type: "string" }
  ];

  statusTypes=[{
    value:'A',
    text:'Activas'
  }
];
  enProceso = false;
  step = 0;
  tableData: any[] = [];
  filteredTable: any[] = [];
  searchText = '';
  msgError = '';
  data!: LoginUserModel;
  tokenMovil: string = '';
  formDriver!: FormGroup;
  today = new Date();
  isSuccessOnly = false;
  isSuccess = false;

  tableButtons = [
    {
      text: 'Detalle',
      action: (event: any) => this.showQRModal(event),
      icon: 'Info',
      hasIcon: true,
      color: '',
      showText: false,
      show: true,
    },

    {
      text: 'Cancelar',
      action: (event: any) => this.cancelRow(event),
      icon: 'Trash',
      hasIcon: true,
      color: '',
      showText: false,
      show: true,
    },
    {
      text: 'Reenviar',
      action: (event: any) => this.resendCode(event),
      icon: '',
      hasIcon: true,
      color: '',
      showText: false,
      show: true,
    }
  ];
  isFromCard = false;
  description: any;
  headers: any[] = [];
  items: any[] = [];
  card: any;
  cardInfo: any = {};
  loadTypeValue: any[] = [];
  prodcutTypeValue: any[] = [];
  selectedValueLoadType!: number;
  selectedValueProduct!: number;
  isChecked: boolean = true;
  isCheckedTmp: boolean = false;
  kmInput!: number;
  amountInput!: number;
  showModal: boolean = false;
  showSuccessModal: boolean = false;
  showDetailModal: boolean = false;
  showQR: boolean = false;
  showWhatapp: boolean = false;
  dataQR!: any;
  dataWhatapp: any;
  messageModal: string = "";
  qrDescription: string = '';
  qrComments: string = '';
  qrReference: string = '';
  availableDrivers: any[] = [];
  availableUsers: any[] = [];
  movementUsers: any[] = [];

  constructor(
    private services: DevicesService,
    private srv: MovementsService,
    private deviceSrv: DevicesService,
    private loginService: LoginServicesService,
    private logServices: LogService,
    private currencyPipe: CurrencyPipe
    , private titleService: Title, private themeService: ThemeService,
    private service: UsersService,
    private toastSrv: ToastService

  ) {
    this.titleService.setTitle("Generación de QR");
    this.themeService.setTitle("Generación de QR");

    this.tokenMovil = localStorage.getItem('tokenMovil')!;
    this.data = JSON.parse(localStorage.getItem('data')!);
  }
  ngOnInit() {
    this.loadDevices();
    //this.loadUsersMovement();
    this.formDriver = new FormGroup({
      driverName: new FormControl('', Validators.required),
    });
  }

  filterByStatus(status:string){
   this.filterStatus=status;
   
    if(status=='T'){
      this.filteredTable = this.tableData;
    }else{
      this.filteredTable = this.tableData.filter((item) => {
       
        return (
          item.cardStatus==status && !this.isExpired(item.expirationDate)

        );
      })
    }
  
  }

  isSelectedStatus(status:string){
    return this.filterStatus==status;
  }

  getUserType(accessType: string): number {
    if (accessType == 'Consulta') {
      return 0;
    }
    if (accessType == 'Revisión') {
      return 2;
    }
    if (accessType == 'Modificación') {
      return 1;
    } else accessType == 'Finanzas';
    {
      return 3;
    }
  }


  loadDevices() {
    this.isLoader = true;
    let isAdmin = this.data.UserType == 'Administrator' || this.data.UserType == 'Modify';
    this.services
      .loadDevices(this.data.Client_number, this.data.User_id, '', isAdmin)
      .subscribe({
        next: (resp: any) => {
          this.tableData = resp;

          this.filteredTable = this.tableData;
          this.filterByStatus(this.filterStatus);
          this.isLoader = false;
        },
        error: (error: any) => {
          this.tableData = [];
          this.filteredTable = [];
          this.isLoader = false;
          this.msgError = error.error.error;
        },
      });
  }
  searchByText(event: any) {
    const searchText = event.target.value.toLowerCase();
    this.filteredTable = this.tableData.filter((item) => {
      const vehicleFullNumber =
        item.vehicleFullNumber?.toString().toLowerCase() || '';
      const description = item.description?.toString().toLowerCase() || '';
      const nameUser = item.nameUser?.toString().toLowerCase() || '';
      const status = item.cardStatus || '';
      if(this.filterStatus=='T'){
        return (
         ( vehicleFullNumber.includes(searchText) ||
          description.includes(searchText) ||
          nameUser.includes(searchText) )
          &&  !this.isExpired(item.expirationDate)
        );
      }else{
        return (
          (vehicleFullNumber.includes(searchText) ||
          description.includes(searchText) ||
          nameUser.includes(searchText) )&&
          status==this.filterStatus  && !this.isExpired(item.expirationDate)
        );
      }
      
    });

  }

  selectUser(event: any) {
    var selected = event.filter((users: any) => users.type == 2);

    if (selected.length > 0) {
      this.selectedUser = selected[0];
    } else {
      this.selectedUser = null;
    }
  }

  selectDriver(event: any) {
    var selected = event.filter((drivers: any) => drivers.type == 2);

    if (selected.length > 0) {
      this.selectedDriver = selected[0];
    } else {
      this.selectedDriver = null;
    }
  }

  isExpired(expiration: string) {
    return this.today > new Date(expiration);
  }
  getCardIdInfo(card: any, reload: boolean = true) {

    this.card = card;

    if (card.card_id > 0) {
      this.loadingBalance = true;
      if (reload) {
        this.step = 1;
      }

      this.getCurrentCardBalance(
        card.vehicleFullNumber,
        card.digitSecurity, reload
      );



      this.isChoice = true;
    }
  }
  goToConsumptions() {
    this.srv
      .getConsumptionsByGmcId(
        this.card.card_id,
        this.data.Version,
        this.tokenMovil
      )
      .subscribe({
        next: (respConsumptions: any) => {
          this.step = 3;
          this.headers = [
            {
              key: 'expirationDate',
              textHeader: 'Expiración',
              visible: true,
              type: 'fullTime',
            },
            { key: 'statusText', textHeader: 'Status', visible: true },
            { key: 'folio', textHeader: 'Referencia', visible: true },
            { key: 'description', textHeader: 'Descripción', visible: true },
            { key: 'comments', textHeader: 'Comentarios', visible: true },
            { key: 'value', textHeader: 'Cantidad', visible: true }
          ];
          let items = [];
          if (respConsumptions.length > 0) {
           items= respConsumptions.map((item: any) => {
              return {
                ...item,
                statusText: this.generateStatusText(item.status, item.expirationDate),
                value:
                  item.isVolume == 1
                    ? item.fuelQuantity + ' LTS.'
                    : this.currencyPipe.transform(item.fuelAmount),
                disableButton: false,
                buttons: item.status == 1 ? this.setButtons(item) : ['Detalle']
              };
            });   
            const itmesDelete = items
              .filter(
                (e: any) =>
                  e.status == 1 && Date.parse(e.expirationDate) < Date.now()
              )
              .map((e: any) => e.consumptionId);

            if (itmesDelete.length > 0) {

              itmesDelete.forEach(async (value: any) => {
                await this.cancelQR(value);
              });
            }
          }
          this.items = items;          
        },
        error: (err: any) => {
          if (err.status == 401) {
            this.messageModal = 'La petición para generar QR no es válida, cierre sesión e intente de nuevo.'
          } else {
            this.toastSrv.add({ type: "error", message: 'Hubo un problema al consultar información de tarjeta, intente de nuevo o comuníquese con atención al cliente' });
          }
        },
        complete: () => { },
      });
  }

  setButtons(item: any) {
    if (!item.openQrCode) {
      return [
        'Detalle',
        'Cancelar'
      ]
    } else {
      return [
        'Detalle',
        'Cancelar',
        'Reenviar'
      ]
    }
  }

  async resendCode(event: any) {
    this.enProceso = true;
    //openQrCode    
    //await this.sendWhatsapp(event.consumptionId);
    if (event.relatedDriverId > 0) {
      this.selectedType = 3;
      this.loadDrivers(event);
    } else if (event.relatedUserId > 0) {
      this.selectedType = 2;
      this.loadUsers(event);
      
    } else {
      this.selectedType = 1;
      this.selectedDriver = null;
      this.selectedUser = null;
      await this.sendWhatsapp(event.consumptionId);
      this.toastSrv.add({ type: "success", message: 'Se ha enviado el código QR al administrador de la cuenta' });
      this.isSuccess = true;
      this.enProceso = false;
    }
  }

  async cancelRow(event: any) {
    this.enProceso = true;
    await this.cancelQR(event.consumptionId);
    this.getCardIdInfo(this.card, false);
    this.srv
      .getConsumptionsByGmcId(
        this.card.card_id,
        this.data.Version,
        this.tokenMovil
      )
      .subscribe({
        next: (respConsumptions: any) => {
          this.enProceso = false;
          this.step = 3;
          this.headers = [
            {
              key: 'expirationDate',
              textHeader: 'Expiración',
              visible: true,
              type: 'fullTime',
            },
            { key: 'statusText', textHeader: 'Status', visible: true },
            { key: 'folio', textHeader: 'Referencia', visible: true },
            { key: 'description', textHeader: 'Descripción', visible: true },
            { key: 'comments', textHeader: 'Comentarios', visible: true },
            { key: 'value', textHeader: 'Cantidad', visible: true }
          ];
          if (respConsumptions.length > 0) {
            const items = respConsumptions.map((item: any) => {
              return {
                ...item,
                statusText: this.generateStatusText(item.status, item.expirationDate),
                value:
                  item.isVolume == 1
                    ? item.fuelQuantity + ' LTS.'
                    : this.currencyPipe.transform(item.fuelAmount),
                disableButton: false,
                buttons: item.status == 1 ? this.setButtons(item) : ['Detalle']
              };
            });
            this.items = items;
            const itmesDelete = items
              .filter(
                (e: any) =>
                  e.status == 1 && Date.parse(e.expirationDate) < Date.now()
              )
              .map((e: any) => e.consumptionId);

            if (itmesDelete.length > 0) {

              itmesDelete.forEach(async (value: any) => {
                await this.cancelQR(value);
              });
            }
          }
        },
        error: (err: any) => {
          this.isSuccess = false;
          if (err.status == 401) {
            this.messageModal = 'La petición para generar QR no es válida, cierre sesión e intente de nuevo.'
          } else {
            this.toastSrv.add({ type: "error", message: 'Hubo un problema al consultar información de tarjeta, intente de nuevo o comuníquese con atención al cliente' });
          }
        },
        complete: () => { },
      });
  }

  showQRModal(event: any) {
    this.dataQR = {
      status: event.status,
      id: event.consumptionId,
      expiration: this.formatDate(event.expirationDate),
      amount:
        event.isVolume == 1
          ? event.fuelQuantity + ' LTS.'
          : this.currencyPipe.transform(event.fuelAmount),
      QR: event.consumptionIdentifier,
      card: this.card.vehicleFullNumber.split('-')[3],
    };
    this.showDetailModal = true;
  }

  whatsApp(event: any) {
    this.dataWhatapp = event;
    this.showModal = true;
    this.showQR = false;
    this.showWhatapp = true;
  }

  generateStatusText(status: number, expDate: Date) {
    if (status == 1) {
      return "Activo";
    } else if (status == 2) {
      return "Usado";
    } else if (status == 3) {
      return "En proceso";
    } else if (status == 4) {
      return "Cancelado"
    }
    else if (status == 5) {
      return "Expirado"
    }

    let today = new Date();

    if (today > expDate) {
      return "Expirado";
    } else {
      return ""
    }
  }

  backButton() {
    if (this.step == 0) {
      return;
    }
    if (this.step == 1) {
      this.selectedDriver = null;
      this.selectedUser = null;
      this.selectType(1);
      this.selectedType = 1;
    }
    this.step--;
    this.isChoice = false;

  }

  typePerson: any = [{
    value: 1,
    text: 'Administrador',
    selected: true,

  }, {
    value: 2,
    text: 'Usuario',
    selected: false,
  }, {
    value: 3,
    text: 'Conductor',
    selected: false,
  }];
  selectedType = 1;
  selectedUser: any = null;
  selectedDriver: any = null;
  nextStep() {
    this.step++;
  }


  selectType(selected: number) {
    this.selectedType = selected;
    if (selected == 1) {
      this.availableDrivers = [];
      this.availableUsers = [];
    } else if (selected == 2) {
      this.loadUsers(null);
    } else {
      this.loadDrivers(null)
    }
    this.typePerson.map(
      (type: any) => {
        if (selected == type.value) {
          type.selected = true;
        } else {
          type.selected = false;
        }
        return [...this.typePerson, type]
      }
    )
  }

  getCurrentCardBalance(vehicleFullNumber: string, digitSecurity: string, reload: boolean) {
    this.loadingBalance = true;
    const fullCardNumber =
      vehicleFullNumber.replace(/-/g, '').trim() + digitSecurity;

    const log: any = {
      sourceId: 2,
      source: 'Portal Monedero',
      Process: 'getCurrentCardBalance',
      ClientNumber: this.data.Client_number,
      ClientId: this.data.Client_id,
      UserId: this.data.UserTypeId,
      Reference: this.data.UserType,
      request: JSON.stringify({ fullCardNumber })
    };

    this.srv.getCurrentCardBalance(fullCardNumber, this.tokenMovil).subscribe({
      next: (resp: any) => {
        log.response = JSON.stringify(resp);
        if (resp.msg || resp.message || !resp.cardId) {
          this.loadingBalance = false;
          log.message = resp.msg || resp.message || 'Respuesta sin datos de tarjeta';
          log.Code = 1;
          this.SaveLog(log);
          this.toastSrv.add({ type: "error", message: resp.msg || resp.message || 'No se pudo obtener el saldo de la tarjeta' });
          this.step = 0;
          return;
        }
        this.cardInfo = resp;
        log.message = 'Balance consultado correctamente';
        log.Code = 0;
        this.SaveLog(log);
      },
      error: (err: any) => {
        this.loadingBalance = false;
        this.isSuccess = false;
        log.response = JSON.stringify(err.error || err.message);
        log.message = 'Error al consultar balance';
        log.Code = 1;
        this.SaveLog(log);
        if (err.status == 401) {
          this.messageModal = 'La petición para generar QR no es válida, cierre sesión e intente de nuevo.'
        } else {
          this.toastSrv.add({ type: "error", message: 'Hubo un problema al consultar información de tarjeta, intente de nuevo o comuníquese con atención al cliente' });
        }
      },
      complete: () => {
        this.loadType();
        this.loadProduct();

        this.loadingBalance = false;
      },
    });

    this.isChoice = true;
  }

  loadType() {
    this.loadTypeValue = [
      { text: 'POR VOLUMEN', value: 1 },
      { text: 'POR IMPORTE', value: 0 }
    ];

    // Preseleccionar según configuración de la tarjeta
    if (
      this.card.checkDaylyLiters ||
      this.card.checkWeeklyLiters ||
      this.card.checkMonthlyLiters
    ) {
      this.selectedValueLoadType = 1;
    } else if (
      this.card.checkDaylyAmount ||
      this.card.checkWeeklyAmount ||
      this.card.checkMonthlyAmount
    ) {
      this.selectedValueLoadType = 0;
    } else {
      this.selectedValueLoadType = 1;
    }
  }

  loadProduct() {
    this.prodcutTypeValue = [];
    let items = 0;
    const product = this.cardInfo.gasoline.toString();

    if (product.includes('1')) {
      this.prodcutTypeValue[items] = { text: 'REGULAR', value: '1' };
      items++;
    }

    if (product.includes('2')) {
      this.prodcutTypeValue[items] = { text: 'PREMIUM', value: '2' };
      items++;
    }

    if (product.includes('3')) {
      this.prodcutTypeValue[items] = { text: 'DIESEL', value: '3' };
      items++;
    }
    this.selectedValueProduct = this.prodcutTypeValue[0].value;
  }

  onLoadTypeChange(data: any): void {
    this.selectedValueLoadType = data.value

  }

  onProductChange(data: any): void {
    this.selectedValueProduct = data.value

  }

  generateQR() {
    if (this.isCheckedTmp) {
      this.enProceso = true;
      this.srv.GetAuthClientTemporalCode(this.data.Client_number).subscribe({
        next: (resp: any) => {
          this.enProceso = false;
          if (resp.isSuccess) {
            this.qrDescription = '';
            this.qrComments = '';
            this.qrReference = '';
            this.showModal = true;
            this.showQR = false;
            this.showWhatapp = false;
          } else {
            this.toastSrv.add({ type: "error", message: resp.message });
          }
        },
        error: (err: any) => {
          this.enProceso = false;
          this.toastSrv.add({ type: "error", message: 'Hubo un problema al consultar información de tarjeta, intente de nuevo o comuníquese con atención al cliente' });
        }
      })
    } else {
      this.qrDescription = '';
      this.qrComments = '';
      this.qrReference = '';
      this.showModal = true;
      this.showQR = false;
      this.showWhatapp = false;
    }
  }
  toggleCheckbox(event: any) {
    this.isChecked = event.target.checked;
  }

  toggleCheckboxTmp(event: any) {
    this.isCheckedTmp = event.target.checked;
  }

  async sendInfoQR(data: any) {
    this.showModal = false;
    let productId;
    let productDesc;
    let kms: number = 0;
    const isVolume = this.selectedValueLoadType;
    this.kmInput = this.kmInput == undefined ? 0 : this.kmInput;

    if (this.selectedValueProduct == 1) {
      productId = 163;
      productDesc = '87 Oct';
    } else if (this.selectedValueProduct == 2) {
      productId = 164;
      productDesc = '91 Oct';
    } else if (this.selectedValueProduct == 3) {
      productId = 165;
      productDesc = 'Diesel';
    }

    if (!this.isChecked) {
      const result = this.validateOdometer();
      if (result.messange != '') {

      } else {
        kms = result.kms;
      }
    } else {
      kms = this.kmInput;
    }

    if (kms != -1) {
      const result = await this.GetQrCode(
        2152,
        this.cardInfo.cardId,
        isVolume,
        this.amountInput,
        productId,
        productDesc,
        kms,
        data.description,
        data.comment,
        data.reference,
        this.data,
        this.tokenMovil,
        this.isCheckedTmp
      );

      if (result.id==0) {
        //this.getCardIdInfo(this.card);
        this.isSuccess = false;
        this.toastSrv.add({ type: "error", message: result.message });
      }     
      else{
          this.showSuccessModal = true;
          this.dataQR = result;
          this.isFromCard = false;
          this.srv
            .getConsumptionsByGmcId(
              this.card.card_id,
              this.data.Version,
              this.tokenMovil
            )
            .subscribe({
              next: (respConsumptions: any) => {
                this.step = 3;
                this.headers = [
                  {
                    key: 'expirationDate',
                    textHeader: 'Expiración',
                    visible: true,
                    type: 'fullTime',
                  },
                  { key: 'statusText', textHeader: 'Status', visible: true },
                  { key: 'folio', textHeader: 'Referencia', visible: true },
                  { key: 'description', textHeader: 'Descripción', visible: true },
                  { key: 'comments', textHeader: 'Comentarios', visible: true },
                  { key: 'value', textHeader: 'Cantidad', visible: true }
                ];
                if (respConsumptions.length > 0) {
                  const items = respConsumptions.map((item: any) => {
                    return {
                      ...item,
                      statusText: this.generateStatusText(item.status, item.expirationDate),
                      value:
                        item.isVolume == 1
                          ? item.fuelQuantity + ' LTS.'
                          : this.currencyPipe.transform(item.fuelAmount),
                      disableButton: false,
                      buttons: item.status == 1 ? this.setButtons(item) : ['Detalle']
                    };
                  });
                  this.items = items;


                  const itmesDelete = items
                    .filter(
                      (e: any) =>
                        e.status == 1 && Date.parse(e.expirationDate) < Date.now()
                    )
                    .map((e: any) => e.consumptionId);

                  if (itmesDelete.length > 0) {

                    itmesDelete.forEach(async (value: any) => {
                      await this.cancelQR(value);
                    });
                  }
                }
              },
              error: (err: any) => {
                if (err.status == 401) {
                  this.messageModal = 'La petición para generar QR no es válida, cierre sesión e intente de nuevo.'
                } else {
                  this.toastSrv.add({ type: "error", message: 'Hubo un problema al consultar información de tarjeta, intente de nuevo o comuníquese con atención al cliente' });
                }
              },
              complete: () => { },
            });
          }
     
    } else {
        this.isSuccess = false;
        this.toastSrv.add({ type: "error", message: "Kilometraje no válido." });
    }
    this.amountInput = 0;
    this.kmInput = 0;
  }

  validateOdometer() {
    const validOdom: boolean =
      this.cardInfo.odometerValidations.validateOdometerLecture;
    const odomLimit = this.cardInfo.odometerValidations.odometerLectureLimit;
    const lastOdom = this.cardInfo.odometerValidations.lastReportedOdometer;
    const tmpKms: number = this.kmInput;
    let response = {
      kms: -1,
      messange: '',
    };

    if (validOdom == true) {
      if (tmpKms < lastOdom || tmpKms > lastOdom + odomLimit) {
        response.messange =
          'El kilometraje no puede ser menor al último odómetro ni mayor al límite de odómetro registrado.';
      } else {
        response.kms = tmpKms;
      }
    } else {
      if (tmpKms < lastOdom) {
        response.messange =
          'El kilometraje no puede ser menor que el último odómetro registrado.';
      } else {
        response.kms = tmpKms;
      }
    }
    return response;
  }

  async GetQrCode(
    clientIdAPI: number,
    gmcCardId: number,
    isVolume: number,
    amount: number,
    productId: any,
    productDesc: any,
    kms: number,
    description: string,
    comment: string,
    reference: string,
    client: any,
    tokenMobile: string,
    isTemporal: boolean
  ) {
    let log: any = {};
    log.sourceId = 2;
    log.source = 'Portal Monedero';
    log.Process = 'GetQrCode()';
    log.StationNumber = '';
    log.Secuence = gmcCardId.toString() + ' ' + gmcCardId.toString();
    log.Reference = client.UserType;
    log.ClientNumber = client.Client_number;
    log.ClientId = client.Client_id;
    log.UserId = client.UserTypeId;
    log.RFC = '';
    log.Client = JSON.stringify(client);

    let request: any = [];
    request.clientId = clientIdAPI;
    request.expirationTime = 14.0;
    request.purchaseType = 1;
    request.gmcCardId = gmcCardId;
    request.cardId = 0;
    request.phoneNumber = '0';
    request.kms = kms;
    request.is_full_tank = 0;
    request.vehicleId = 0;
    request.invoiceClientId = 0;
    request.fingerprintId = 0;
    request.ip = null;
    request.RequestID = null;
    request.amount = amount;
    request.fuel = 1;
    request.odometro = 'S';
    request.token = tokenMobile;
    request.clientNumber = client.Client_number;
    request.description = description != '' ? description : 'Comentarios generados automáticamente';
    request.comments = "Generado por: " + (this.data.UserType == 'Administrator' ? 'Administrador de la cuenta' : this.data.Name) + ' ' + comment;
    request.folio = reference ?? '';

    request.consumptionUsers = {
      clientNumber: client.Client_number,
      driverId: (this.selectedType == 2 || this.selectedType == 1) ? 0 : this.selectedDriver!.driver_id!,
      userId: (this.selectedType == 3 || this.selectedType == 1) ? 0 : this.selectedUser!.userId!,
      openQrCode: isTemporal
    }
    let p: any = [];
    p.extPrice = 0;
    p.taxRate = 0;
    p.image = '';
    p.description = productDesc;
    p.upc = null;
    p.productId = productId;
    p.productTypeInt = 1;
    p.productType = null;
    p.consumptionId = 0;
    p.detailId = 0;
    p.kms = kms;
    p.productPriceServed = 0;

    if (isVolume == 0) {
      request.isVolume = isVolume;
      p.unitsPurchased = amount;
      p.unitCost = 0;
      p.unitPrice = 1;
    } else if (isVolume == 1) {
      request.isVolume = isVolume;
      p.unitsPurchased = amount;
      p.unitCost = 0;
      p.unitPrice = 0;
    }
    let list: any = [];
    list.push({ ...p });
    request.products = list;

    log.request = JSON.stringify({ ...request });
   

    try {
      const result = await this.GetDataCode(
        { ...request },
        client.Client_number,
        tokenMobile
      );
      
   
      if (result.consumptionId == 0) {    
        log.response = JSON.stringify(result);
        log.message = '[Folio:' + 0 + '] ' + result.message;
        log.TypeId = 0;
        log.Type = 'Generación de QR';
        log.File = 'QRCode.aspx';
        log.Code = 1;
        this.SaveLog(log);
        return {
          id: 0,
          expiration: '',
          amount: '',
          QR: '',
          message: result.message,
          card: this.card.vehicleFullNumber.split('-')[3],
          status: 0
        };      
      }
      
      log.response = JSON.stringify(result);
      log.message = 'Se generó correctamente: Folio:' + result.consumptionId;
      log.typeId = 0;
      log.type = 'Generación de QR';
      log.file = 'QRCode.aspx';
      log.code = 0;
      this.SaveLog(log);
      if (this.isCheckedTmp) {
        this.sendWhatsapp(result.consumptionId);
      }

      return {
        id: result.consumptionId,
        expiration:  result.expirationDate.replace('T', ' '), //   array[2].replace(/['"]/g, '') + ' ' + array[3].replace(/['"]/g, ''),
        amount: parseFloat(request.amount).toFixed(2) + ' M.N. ' +   request.products[0].description.toUpperCase(),// array[5].replace(/['"]/g, ''),
        QR: result.consumptionIdentifier,
        message: result.message,
        card: this.card.vehicleFullNumber.split('-')[3],
        status: 1
      };    
   

    } catch (error: any) {
      log.response = JSON.stringify(null);
      log.message = '[Folio:' + 0 + '] ' + error.message;
      log.TypeId = 0;
      log.Type = 'Generación de QR';
      log.File = 'QRCode.aspx';
      log.Code = 1;
      this.SaveLog(log);
      return {
        id: 0,
        expiration: '',
        amount: '',
        QR: '',
        message: error.message,
        card: this.card.vehicleFullNumber.split('-')[3],
        status: 0
      };
    }
  }

 async GetDataCode(RequestObj: any, clientNumber: string, token: string): Promise<any> {
  try {
    return await firstValueFrom(this.srv.GetDataCode(RequestObj, token));
  } catch (err: any) {
    return {
      consumptionId: 0,
      message: err.error?.error || err.message || 'Error al generar QR'
    };
  }
}
   

  ConsumptionComments(
    folioQR: number,
    description: string,
    comments: string,
    reference: string
  ) {
    const log = {
      consumption_id: folioQR.toString(),
      description: description,
      comments: comments,
      reference: reference,
    };
    this.logServices.saveConsumptionComments(log).subscribe({
      next: (resp: any) => {
        if (resp) {
        } else {

        }
      },
      error: (err: any) => {
        this.toastSrv.add({ type: "error", message: err.error.error });
      },
      complete: () => { },
    });
  }

  SaveLog(log: any) {
    this.logServices.saveLog(log).subscribe({
      next: (resp: any) => {
        if (resp) {
        } else {
        }
      },
      error: (err: any) => {
        this.toastSrv.add({ type: "error", message: err.error.error });
      },
      complete: () => { },
    });
  }

  CancelQRCode(
    consumptionId: number,
    clientNumber: string,
    token: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this.srv.CancelQRConsumption(consumptionId, token).subscribe({
        next: (resp: any) => {
          resolve(resp);
        },
        error: (err: any) => {
          if (err.status == 401) {
            const password = this.loginService.getData('password');
            this.loginService
              .loginMovil(+clientNumber, password, false, this.data.Version)
              .subscribe({
                next: (response: any) => {
                  const tokenEx = response.clientData.token;
                  this.CancelQRCode(consumptionId, clientNumber, tokenEx)
                    .then(resolve)
                    .catch(reject);
                },
              });
          } else {
            reject(err);
          }
        },
        complete: () => { },
      });
    });
  }

  async cancelQR(consumptionId: number) {
    const client: any = this.data;
    let log: any = {};
    log.SourceId = 2;
    log.Source = 'Portal Monedero';
    log.Process = 'btn_cancela_Click()';
    log.StationNumber = '';
    log.Secuence = this.items[0].gmcCardId + ' ' + this.items[0].gmcCardId;
    log.Reference = client.UserType;
    log.ClientNumber = client.Client_number;
    log.ClientId = client.Client_id;
    log.UserId = client.UserTypeId;
    log.RFC = '';
    log.Client = JSON.stringify(client);
    const request = {
      consumptionId: consumptionId,
      consumptionIdentifier: null,
      clientId: 0,
      name: null,
      authorization: null,
      creationDate: null,
      expirationDate: null,
      fuelAmount: null,
      statusInt: null,
      fuelQuantity: null,
      productsAmount: null,
      station: null,
      gmcCardId: null,
      isVolume: null,
      description: null,
      folio: null,
      reference: null,
      comments: null,
      message: null,
    };
    let process = {
      descripcion: '',
      codigo: 0,
      mensaje: '',
      response: '',
      ObjetosMultimedia: null,
      Consumos: null,
      responseStream: null,
      valido: true,
      jsonData: '',
      jsonMagna: '',
      jsonPremium: '',
      jsonDiesel: '',
    };

    log.Request = JSON.stringify(request);
    try {
      await this.CancelQRCode(
        consumptionId,
        client.Client_number,
        this.tokenMovil
      );
      log.Response = JSON.stringify(process);
      log.Message = 'Se se canceló correctamente: ' + process.codigo;
      log.TypeId = 0;
      log.Type = 'Generación de QR';
      log.File = 'QRCode.aspx';
      log.Code = 0;
      this.SaveLog(log);
    } catch (error: any) {
      log.Message = error.message;
      log.TypeId = 0;
      log.Type = 'Generación de QR';
      log.File = 'QRCode.aspx';
      log.Code = 1;
      this.SaveLog(log);
    }
    this.amountInput = 0;
    this.kmInput = 0;
  }

  async sendWhatsapp(consumptionId: number) {
    this.dataWhatapp
    this.showModal = false;
    const client: any = this.data;


    let log: any = {};
    log.SourceId = 2;
    log.Source = "Portal Monedero";
    log.Process = "btn_enviarQR_Click";
    log.StationNumber = '';
    log.Secuence = this.card.card_id + ' ' + this.card.card_id;
    log.Reference = client.UserType;
    log.ClientNumber = client.Client_number;
    log.ClientId = client.Client_id;
    log.UserId = client.UserTypeId;
    log.RFC = '';
    log.Client = JSON.stringify(client);

    try {

      /*
        driverId: (this.selectedType == 2 || this.selectedType == 1) ? 0 : this.selectedDriver!.driver_id!,
      userId: (this.selectedType == 3 || this.selectedType == 1) ? 0 : this.selectedUser!.userId!,
      */
      let RequestObj = {
        name: this.data.UserType == 'Administrator' ? "Administrador de la cuenta: " + this.data.Client_number : this.data.Name,
        referenceData: { consumptionId: consumptionId },
        phoneNumber: "",
        areaCode: "",
        clientNumber: this.data.Client_number,
      };


      if (this.selectedType == 1) {
        RequestObj.phoneNumber = this.data.Phone;
        RequestObj.areaCode = "52";
      } else if (this.selectedType == 2) {
        let phone = this.selectedUser.fullPhone.includes(' ') ? this.selectedUser.fullPhone.split(' ')[1] : this.selectedUser.fullPhone;
        let areaCode = this.selectedUser.fullPhone.includes(' ') ? this.selectedUser.fullPhone.split(' ')[0] : "52";
        RequestObj.phoneNumber = phone;
        RequestObj.areaCode = areaCode;
        RequestObj.name = this.selectedUser.name;
      } else if (this.selectedType == 3) {
        let phone = this.selectedDriver.fullPhone.includes(' ') ? this.selectedDriver.fullPhone.split(' ')[1] : this.selectedDriver.fullPhone;
        let areaCode = this.selectedDriver.fullPhone.includes(' ') ? this.selectedDriver.fullPhone.split(' ')[0] : "52";
        RequestObj.phoneNumber = phone;
        RequestObj.areaCode = areaCode;
        RequestObj.name = this.selectedDriver.name;
      }




      const result = await this.SendCodeByWhatsAppV2(RequestObj, client.Number, this.tokenMovil)
      log.Message = result.message;
      log.TypeId = 0;
      log.Type = "QR-Whatsapp";
      log.File = "QRCode";
      log.Code = 1;
      this.SaveLog(log);
    }
    catch (error: any) {
      log.Message = error.message;
      log.TypeId = 0;
      log.Type = "QR-Whatsapp";
      log.File = "QRCode.aspx.cs";
      log.Code = 1;
      this.SaveLog(log);

    }

  }

  SendCodeByWhatsAppV2(
    RequestObj: any,
    clientNumber: string,
    token: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this.srv.SendCodeByWhatsAppV2(RequestObj).subscribe({
        next: (resp: any) => {
          resolve(resp);
        },
        error: (err: any) => {
          this.messageModal=err.error.error;
        },
        complete: () => { },
      });
    });
  }

  formatDate(d: string): string {
    const date = new Date(d);
    const options: Intl.DateTimeFormatOptions = {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    return date.toLocaleString('en-US', options);
  }

  resetScreen() {
    this.availableDrivers = [];
    this.availableUsers = [];
    this.selectedDriver = null;
    this.selectedUser = null;
    this.selectedType = 0;
    this.showQR = false;
    this.isCheckedTmp = false;
    this.isChecked = true;
    this.selectType(1);
    this.showModal = false;
    this.showSuccessModal = false;
    this.showDetailModal = false;
    this.step = 0;
  }

   loadUsers(event:any) {
    this.loadingUsers = true;
    this.deviceSrv.searchUsersByCard(this.data.Client_number, this.card.card_id,false).subscribe({
      next: async (resp: any) => {
        const usersWithType = resp.map((userCard: any) => {

          return {
            ...userCard,
            fullPhone: userCard.phoneAreaCode + " " + userCard.phone,
            type: 0
          };

        });
        this.availableUsers = usersWithType;
        if(event){
         
          this.selectedUser = this.availableUsers.find((d: any) => d.userId == event.relatedUserId);
          
          await this.sendWhatsapp(event.consumptionId);
          this.toastSrv.add({ type: "success", message: 'Se ha enviado el código QR al usuario: ' + this.selectedUser.name });
          this.isSuccess = true;
          this.enProceso = false;
        }
        this.loadingUsers = false;
      },
      error: (err: any) => {
        this.toastSrv.add({ type: "error", message: err.error.error });
        this.loadingUsers = false;
      }
    });
  }

  loadDrivers(event:any) {
    this.loadingUsers = true;
    this.services.getDrivers(this.data.Client_number,false).subscribe({
      next: (resp: any) => {
        if (resp.length > 0) {
          let allDrivers = resp.map((item: any) => {
            return {
              ...item,
              type: 0,

            };
          });

          this.srv.getDriverTable(this.card.card_id, this.data.Client_id).subscribe({
            next: async (respDrivers: any) => {
              if (respDrivers.message === '') {
                respDrivers.response.items.forEach((element: any) => {
                  let found = allDrivers.findIndex((d: any) => d.driver_id == element.driver_id);
                  if (found > -1) {
                    element.fullPhone = allDrivers[found].phone_number;
                  }else{
                   let index= respDrivers.response.items.findIndex((e:any) => e ==element);
                   if(index>-1){
                    respDrivers.response.items.splice(index,1);
                   }
                  }
                });
                const modifiedResponse = respDrivers.response.items.map((item: any) => {
                  return { ...item, type: 0 };
                });

                this.availableDrivers = modifiedResponse;
                if(event){
                  this.selectedDriver = this.availableDrivers.find((d: any) => d.driver_id == event.relatedDriverId);

                   await this.sendWhatsapp(event.consumptionId);
                  this.toastSrv.add({ type: "success", message: 'Se ha enviado el código QR al conductor: ' + this.selectedDriver.name });
                  this.isSuccess = true;
                  this.enProceso = false;
                }
                this.loadingUsers = false;
              }
            },
            error: (err: any) => {
              this.loadingUsers = false;
              this.toastSrv.add({ type: "error", message: err.error.error });
            },
            complete: () => { },
          });

        } else {
          this.messageModal =
            'Esta cuenta no tiene conductores dados de alta';
        }
      },
      error: (err: any) => {
        this.messageModal =
          'Hubo un problema para obtener a los conductores, refresque e intente de nuevo';
      },
      complete: () => {
        this.loadingUsers = false;
      },
    });
  }

  getTextUser() {
    if (this.selectedType == 1) {
      return "Administrador de la cuenta";
    } else if (this.selectedType == 2) {
      return this.selectedUser.name;
    } else if (this.selectedType == 3) {
      return this.selectedDriver.name;
    }
  }

}

